import {MEMBERSHIPS} from '../constants/memberships'
import { setActiveTab, setActiveSubTab } from '../../redux/actions/tabsActions';
import { INFO_PAGO_TAB_INDEX } from '../constants/tabs';
import { ACCESS_ACTION } from '../../design-system/constants/access-action';

export const getPreviousMembership = (membership, memberships) => {
    if (membership?.level > 1) {
        if (memberships?.length > 0) {
            const previousItem = memberships.find((m, i, o) => m.level === (membership.level - 1));
            return previousItem;
        }
    }

    return null;
};


export const validateMembership = (userMembership) => {
    if (!userMembership || !userMembership.end_date) {
        return false;
    }
    if(userMembership.id !== MEMBERSHIPS.FREEMIUM){
        const fechaComprobar = new Date(userMembership.end_date);
        const ahora = new Date();
        return fechaComprobar < ahora;
    }
    return false;
}

/**
 * Resuelve qué acción ofrecer sobre las materias de un programa comparando las
 * membresías que lo habilitan contra la del alumno.
 *
 * Falla abierto a propósito: solo bloquea cuando hay evidencia positiva de que
 * la membresía no alcanza. Si el backend no envía `membresia_id` (llega null o
 * vacío) se conserva el comportamiento anterior, para no encerrar a alumnos con
 * materias en curso por un dato faltante.
 *
 * @param {object} params
 * @param {number[]|null} params.membresiaIds Membresías que habilitan el programa.
 * @param {object|null} params.userMembership Membresía vigente del alumno.
 * @param {boolean} params.membershipExpired Si la membresía del alumno ya venció.
 * @returns {string} Una de las ACCESS_ACTION.
 */
export const resolveProgramAccessAction = ({ membresiaIds, userMembership, membershipExpired }) => {
    const hasEntitlementData = Array.isArray(membresiaIds) && membresiaIds.length > 0;

    if (hasEntitlementData && !membresiaIds.includes(userMembership?.id)) {
        return ACCESS_ACTION.UPGRADE;
    }

    return membershipExpired ? ACCESS_ACTION.RENEW : ACCESS_ACTION.ENROLL;
};

export const redirectMembershipView = (e, dispatch, history) => {
    if (e?.preventDefault) {
        e.preventDefault();
    }
    if (e?.stopPropagation) {
        e.stopPropagation();
    }
    dispatch(setActiveTab(INFO_PAGO_TAB_INDEX));
    dispatch(setActiveSubTab(2));
    history.push('/profile');
    return true;
};